export const ItemTypes = {
  TEMPERATURE: 'temperature',
  ICON: 'icon',
  DANGER: 'danger',
  FOG: 'fog',
  WIND_DIRECTION: 'wind-direction',
  WIND_STRENGTH: 'wind-strength'
};
